
import React from 'react';
import ArcherHeroBlock from './components/ArcherHeroBlock/ArcherHeroBlock';
import Result from './components/Result/Result';
import ContactBlock from '../energy-calculator/components/contactBlock/ContactBlock';
import ReferenceBlock from '../energy-calculator/components/referenceBlock/ReferenceBlock';

const ArcherCalculator = (props) => {

    const [startCount, setStartCount] = React.useState(false);

    const handleDialogPopup = (version) => {
        let dialog;
        switch (version) {
            case 'result':
                setStartCount(!startCount);
                dialog = document.querySelector('.calculator__result-dialog');
                dialog.addEventListener('keydown', function (event) {
                    if (event.key === 'Escape') {
                        event.preventDefault(); // Prevent the dialog from closing
                    }
                });
                break;
            default:
                break;
        }
        if (dialog.hasAttribute('open')) {
            dialog.close();
        } else {
            dialog.showModal();
        }
    };

    return (
        <div className='energy-calculator-wrapper'>
            <div className='calculator-wrapper'>
                <ArcherHeroBlock {...props} handleDialogPopup={handleDialogPopup} />

                <Result
                    {...props}
                    startCount={startCount}
                    handleDialogPopup={handleDialogPopup} />

                <ContactBlock {...props} />
                {props.mainContentArea && props.mainContentArea.value && props.mainContentArea.value.length > 0 && <ReferenceBlock {...props} />}
            </div >
        </div >

    );
};
import PropTypes from 'prop-types';

ArcherCalculator.ropTypes = {
    id: PropTypes.string
};

export default ArcherCalculator;
